import React from 'react';
import { Button, ButtonsGroup, Title } from 'components/commons';
import useNavigation from 'hooks/navigation';
import vectorIcon from 'assets/svg/vector.svg';
import arrowRightIcon from 'assets/svg/arrow-right.svg';

import './bizon-invalid-partner.styles.scss';

const InvalidPartner: React.FC = (): JSX.Element => {
    const {
        goToShareAntiFraudPartner,
        goToAntiFraudCheckout,
    } = useNavigation();

    return (
        <div className="bizon-invalid-partner">
            <div className="bizon-invalid-partner__content">
                <div>
                    <Title className="bizon-invalid-partner__title">ops! não encontramos o registro deste sócio</Title>
                    <span className="bizon-invalid-partner__text">Talvez este CPF ainda não esteja registrado como sócio desta empresa. <b>Envie esse link para o sócio continuar o processo.</b></span>

                </div>
                <div className="bizon-invalid-partner__why">
                    <img
                        className="bizon-invalid-partner__icon" src={vectorIcon}
                    />
                    <span className="bizon-invalid-partner__sub-title" >Por que precisamos confirmar?</span>
                    <span className="bizon-invalid-partner__description" >Para sua análise de crédito ser válida a partir daqui pediremos dados e fotos do rosto do sócio.</span>
                </div>
            </div>
            <div className="bizon-invalid-partner__footer">
                <ButtonsGroup>
                    <button
                        className="btn-biz secondary"
                        type="button"
                        onClick={goToAntiFraudCheckout}
                    >
                        <img
                            className="hidden-lg" src={arrowRightIcon}
                        />
                        <span className="hidden-sm">voltar</span>
                    </button>
                    <Button
                        type="button"
                        label="enviar para o sócio"
                        onClick={goToShareAntiFraudPartner}
                    />
                </ButtonsGroup>
            </div>
        </div>
    );
};

export default InvalidPartner;
